import { render, staticRenderFns } from "./ConfirmOrderModal.vue?vue&type=template&id=00540792"
import script from "./ConfirmOrderModal.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports